import React from 'react';

/**
 * Wrapper konten dengan lebar maksimal dan padding konsisten.
 * @param {string} className - class tambahan
 * @param {React.ReactNode} children
 */
function Container({ className = '', children, ...rest }) {
  return (
    <div className={`max-w-6xl mx-auto px-4 ${className}`.trim()} {...rest}>
      {children}
    </div>
  );
}

export default Container;
